$(function() {
    iniLikeIcon();
    iniAllLikeIcons();
    iniLikeIconOnChange();
    getNoCacheLikesAndComments();
});

export function iniLikeIconOnChange(){
    var target = document.querySelector("body");
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            iniAllLikeIcons();
        });

    
    });

    // Observer configuration:
    var config = { attributes: true, childList: true, characterData: true };

    // Observer on
    observer.observe(target, config);
}

export function iniLikeIcon(iconId = null){
    var likeIconElement = null;
    if(iconId != null){
        likeIconElement = document.getElementById(iconId);
    }else{
        likeIconElement = document.getElementById("likeIcon");
    }
    if(likeIconElement != null){
        var blogId = likeIconElement.dataset.articleId;
        var cname = "likeArticle"
        if(checkCookie(cname, blogId)){
            likeIconElement.classList.add('like-filled');
            likeIconElement.classList.remove('like-empty');
        }
    }
    
}

export function iniAllLikeIcons(){
    var hearts_icons = document.getElementsByClassName("like-icon-heart");
    [].forEach.call(hearts_icons, function (el) {
        iniLikeIcon(el.id);
    });
}

function deleteCookieLikeBlog(blogId){
    var exitOnError = true;
    var likeCookie = tech.core.getCookie("likeArticle", exitOnError);
    var splitCookie = likeCookie.split(",");
    const index = splitCookie.indexOf(blogId);
    if(index > -1){
        var cvalue = "";
        splitCookie.splice(index, 1);
        var cookieLength = splitCookie.length;
        for (let i = 0; i < cookieLength; i++) {
            var id = splitCookie[i];
            cvalue += i+1 < cookieLength ? id+"," : id;  
        }
        setLikeBlogCookie(cvalue, 365);
    }
}


function checkCookie(cname, cvalue){
    var exitOnError = true;
    var likeCookie = tech.core.getCookie(cname, exitOnError);
    if(likeCookie.search(cvalue) >= 0){
        return true;
    }
    return false;
}

function setLikeBlogCookie(cvalue, expireDays){
    var d = new Date();
    d.setTime(d.getTime() + (expireDays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = "likeArticle=" + cvalue + ";" + expires + ";path=/";
}

function sendLike(verb, articleId, likeNumberSpan = null){
    $.ajax({
        type: 'POST',
        url: tech.core.getInternationalUrl('/Articles/SendArticleLikeUnlike'),
        data: { verb: verb, articleId: articleId },
        success: "ok"
    });

    var likeNumber = null;
    if(likeNumberSpan != null){
        likeNumber = document.getElementById(likeNumberSpan);
    }else{
        likeNumber = document.getElementById("likeNumber");
    }
    if(verb === "likeUp"){
        likeNumber.textContent++;
    }else{
        if(likeNumber.textContent -1 >= 0){
            likeNumber.textContent--;
        }
    }
}

export function sendLikeOrDislike(event, iconId, likeNumberSpan = null){
    event.preventDefault();
    event.stopPropagation();
    var likeIconElement = document.getElementById(iconId);
    var blogId = likeIconElement.dataset.articleId;
    if (!checkCookie("likeArticle", blogId)){
        var likeCookie = tech.core.getCookie("likeArticle", true);
        var cvalue = likeCookie.trim() === "" ? blogId : likeCookie+","+blogId; 
        setLikeBlogCookie(cvalue, 365);
        likeIconElement.classList.add('like-filled');
        likeIconElement.classList.remove('like-empty');
        sendLike("likeUp", blogId, likeNumberSpan);
    }else{
        likeIconElement.classList.add('like-empty');
        likeIconElement.classList.remove('like-filled');
        deleteCookieLikeBlog(blogId);
        sendLike("likeDown", blogId, likeNumberSpan);
    }
}

export function getNoCacheLikesAndComments(){
    var hearts_icons = document.getElementsByClassName("like-icon-heart");
    var idsList = generateBlogIdList(hearts_icons);
    
    $.ajax({
        type: 'GET',
        url: tech.core.getInternationalUrl('/Blog/GetPostNumbers'),
        data: {idsList: idsList},
        success: function(apiResponse){
            if(apiResponse.success == true){
                repaintLikeNumbers(apiResponse.postsNumbers, hearts_icons);
            }
            
        }
    });
}

function repaintLikeNumbers(postsNumbers, hearts_icons){
    [].forEach.call(hearts_icons, function (el) {
        postsNumbers.find(postNumbers => {
            if(postNumbers.id == el.dataset.articleId){
                let likeIconIdSplit = el.id.split("-");
                let likeNumber = null;
                if(likeIconIdSplit[1]){
                    likeNumber = document.getElementById("likeNumber-"+likeIconIdSplit[1]);
                }else{
                    // This is Blog/details main heart
                    likeNumber = document.getElementById("likeNumber");
                }
                if(likeNumber){
                    likeNumber.textContent = postNumbers.likes;
                }
                
            }
        })
    });
}

function generateBlogIdList(hearts_icons){
    let idsList = "";
    for (const el of hearts_icons) {
        idsList += el.dataset.articleId+",";
    }
    return idsList;
}



